export default {
  'cohortAttritionTab.stepTitle': 'Attrition',
  'cohortAttritionTab.stepDescription':
    'View the number of patients remaining and excluded after each cohort criterion was applied.',
  'projects.cohortAttritionTable.criterion': 'Criterion',
  'projects.cohortAttritionTable.patientsRemaining': 'Patients remaining',
  'projects.cohortAttritionTable.patientsRemainingPercent': 'Patients remaining percent',
  'projects.cohortAttritionTable.patientsExcluded': 'Patients excluded',
  'projects.cohortAttritionTable.patientsExcludedPercent': 'Patients excluded percent',

  // Workflow messages
  'projects.cohortAttritionTable.workflowMessage.loadingTitle': 'Loading attrition...',
  'projects.cohortAttritionTable.workflowMessage.title': 'Processing attrition',
  'projects.cohortAttritionTable.workflowMessage.draft':
    'Process the cohort to view attrition data for subjects who meet all cohort criteria.',
  'projects.cohortAttritionTable.workflowMessage.processing':
    'Attrition data for subjects who meet all cohort criteria will be available once cohort processing is complete.',
  'projects.cohortAttritionTable.workflowMessage.error':
    'Edit and/or reprocess the cohort to view attrition data for subjects who meet all cohort criteria.',

  // Error messages
  'projects.cohortAttritionTable.noResults': 'No attrition results available.',
  'projects.cohortAttritionTable.noRows.attritionProcessing':
    'No attrition results available. Wait for processing to complete to view the attrition results.',

  // Tooltips
  'projects.cohortAttritionTable.patientsRemainingTooltip':
    'Number of patients remaining at this step. Percentage is calculated as: (patients remaining / total patients in the dataset) x 100.',
  'projects.cohortAttritionTable.patientsExcludedTooltip':
    'Number of patients excluded at this step. Percentage is calculated as: (patients excluded /patients remaining in previous step) x 100.',

  // Workflow messages - draft
  'projects.cohortAttritionTable.workflowMessage.draft.title': 'No attrition',
  'projects.cohortAttritionTable.workflowMessage.draft.message':
    'Process the cohort to view attrition data for subjects who meet all cohort criteria.',
  'projects.cohortAttritionTable.workflowMessage.processing.title': 'No attrition',
  'projects.cohortAttritionTable.workflowMessage.processing.message':
    'Attrition data for subjects who meet all cohort criteria will be available once cohort processing is complete.',
  'projects.cohortAttritionTable.workflowMessage.error.title': 'No attrition',
  'projects.cohortAttritionTable.workflowMessage.error.message':
    'Edit and re-process the cohort to view attrition data for subjects who meet all cohort criteria.',
};
